export const faqQuestions = [
    {
        id: "1",
        category: "Getting started",
        question: "What is Mooz?",
        description:
            "Mooz is an AI-powered interview platform that helps you practise, record, and review your answers in a realistic interview environment. You’ll receive feedback on structure, communication quality, and relevance to the question, so every session helps you perform better in the real thing.",
    },
    {
        id: "2",
        category: "Getting started",
        question: "Why was Mooz created?",
        description:
            "Mooz was built to make interview preparation less intimidating and more effective. We understand that landing a job is more than just having a polished resume; nailing the interview is just as important. After noticing how many candidates struggle with confidence and self-assessment, we set out to create a tool that lets you practise in a safe, judgment-free environment. By combining AI-driven feedback with thoughtful design, Mooz empowers you to improve your communication, reflect on your performance, and walk into every interview with more confidence.",
    },
    {
        id: "3",
        category: "Getting started",
        question: "How does Mooz work?",
        description:
            "Once you sign in, you can choose from a library of interview questions tailored to your industry. Record your responses using your camera and microphone, then review your personalised feedback. Your performance data is saved in your dashboard, where you can track progress over time and identify areas for improvement.",
    },
    {
        id: "4",
        category: "Using Mooz",
        question: "Is Mooz free to use?",
        description:
            "You can get started for free with core features like a curated list of questions based on your role. Extra features like a personalised feedback analysis and expanded question library are available with a premium plan for users who want deeper prep and sharper results.",
    },
    {
        id: "17",
        category: "Using Mooz",
        question: "Do I need an account to use Mooz?",
        description:
            "Yes. You’ll need to sign up using a verified email address. Authentication is managed securely through Auth0, which means your login credentials are encrypted and never stored directly by Mooz. Your data stays private, and you can delete your account at any time.",
    },
    {
        id: "5",
        category: "Using Mooz",
        question: "Can I review my past recordings?",
        description:
            "Absolutely. Every recording and feedback session is saved to your profile. You can replay past answers, compare feedback across attempts, and monitor your growth through dashboard analytics. ",
    },
    {
        id: "6",
        category: "Using Mooz",
        question: "How accurate is the AI feedback?",
        description:
            "Mooz uses natural language processing and sentiment analysis models to provide objective, data-driven insights. It analyses your structure and clarity, communication quality, and relevance to the question against proven communication patterns. While the AI feedback is highly consistent, we recommend pairing it with real-world mock interviews (for example, through Exponent) for best results.",
    },
    {
        id: "7",
        category: "Security",
        question: "Is my data secure?",
        description:
            "Yes, security and privacy are central to Mooz’s design. All recordings and feedback data are stored securely in encrypted databases, and authentication is handled by Auth0. You remain in full control of your data, and you can delete your account or recordings at any time.",
    },
    {
        id: "8",
        category: "Pricing",
        question: "What’s included in the Free plan?",
        description:
            "The Free plan gives you the core practise features: question bank access, recording tools, and replay to review your answers.",
    },
    {
        id: "9",
        category: "Pricing",
        question: "What do I get with Pro AI?",
        description:
            "Pro AI includes everything in Free plus AI feedback, deeper insights, and higher limits for consistent practise and measurable improvement.",
    },
    {
        id: "10",
        category: "Pricing",
        question: "Can I cancel anytime?",
        description:
            "Yes. You can cancel anytime and keep access until the end of your current billing period.",
    },
    {
        id: "11",
        category: "Security",
        question: "How do you handle my recordings?",
        description:
            "Your recordings are private and tied to your account. You control what you keep or delete.",
    },
    {
        id: "12",
        category: "Using Mooz",
        question: "I have a question. How do I contact you?",
        description:
            '<a className="body-link" href="/contact" target="blank">Email us</a> directly and we will get back to you at the earliest convenience.',
    },
    {
        id: "13",
        category: "Pricing",
        question: "Is Mooz free to use?",
        description:
            "Yes. You can start practising for free. Upgrade only if you want to access wider analytics features.",
    },
    {
        id: "14",
        category: "Using Mooz",
        question: "Do I need to download anything?",
        description: "No. Mooz works entirely in your browser.",
    },
    {
        id: "15",
        category: "Using Mooz",
        question: "Are my recordings private?",
        description:
            "Yes. Your recordings are private by default and only visible to you.",
    },
    {
        id: "16",
        category: "Using Mooz",
        question: "Is this useful if I already practise answers?",
        description:
            "Yes. Speaking out loud on camera reveals gaps you won’t catch by rehearsing in your head.",
    },
    // {
    //     id: "",
    //     question: "",
    //     description: "",
    // },
];
